import React, { useState } from 'react';
import { ManageProfileCACS } from './manage_profile_cacs';
import { ManageBankDetailsCACS } from './manage_bank_details_cacs';

export const SettingsCACS = () => {
    const [selectedTab, setSelectedTab] = useState('profile'); // 'profile' or 'bank'

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                padding: '20px 42px',
                borderBottom: '1px solid #eee',
                backgroundColor: 'white'
            }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <div
                        onClick={() => setSelectedTab('profile')}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 15px',
                            borderBottom: selectedTab === 'profile' ? '3px solid #3765A5' : '3px solid transparent',
                            color: selectedTab === 'profile' ? '#3765A5' : '#666',
                            fontWeight: selectedTab === 'profile' ? '600' : '400'
                        }}
                    >
                        Edit Profile
                    </div>
                    <div
                        onClick={() => setSelectedTab('bank')}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 15px',
                            borderBottom: selectedTab === 'bank' ? '3px solid #3765A5' : '3px solid transparent',
                            color: selectedTab === 'bank' ? '#3765A5' : '#666',
                            fontWeight: selectedTab === 'bank' ? '600' : '400'
                        }}
                    >
                        Manage Bank Details
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, overflowY: 'auto' }}>
                {selectedTab === 'profile' && <ManageProfileCACS />}
                {selectedTab === 'bank' && <ManageBankDetailsCACS />}
            </div>
        </div>
    );
};
